import { render, staticRenderFns } from "./IndexHome.vue?vue&type=template&id=ee3d0aee&scoped=true"
import script from "./IndexHome.vue?vue&type=script&lang=js"
export * from "./IndexHome.vue?vue&type=script&lang=js"
import style0 from "./IndexHome.vue?vue&type=style&index=0&id=ee3d0aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3d0aee",
  null
  
)

export default component.exports